import { render } from "./open-formal.vue?vue&type=template&id=b255c66e&scoped=true"
import script from "./open-formal.vue?vue&type=script&lang=ts"
export * from "./open-formal.vue?vue&type=script&lang=ts"

import "./open-formal.vue?vue&type=style&index=0&id=b255c66e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b255c66e"

export default script